<template>
  <div class="question">
    <el-row type="flex">
      <div style="margin-right: 10px;">
        <el-button type="primary" @click="openDialog('add')">新 增</el-button>
      </div>
      <div style="margin-right: 10px;">
        <el-select v-model="parentItem" filterable @change="handleSelect" value-key="id">
          <el-option v-for="item in listParents" :key="item.id" :label="item.errorType"
                     :value="item"></el-option>
        </el-select>
      </div>
      <div style="margin-right: 10px;">
        <el-button type="primary" @click="deleteParent">删除父级</el-button>
      </div>
      <div style="margin-right: 10px;">
        <el-input placeholder="请输入要搜索的内容" v-model="queryKeyWord" clearable>
          <el-button slot="append" icon="el-icon-search" @click="getKeyWordList"></el-button>
        </el-input>
      </div>
    </el-row>
    <el-divider></el-divider>
    <el-table border :header-cell-style="{ textAlign: 'center' }" :data="listTable" v-loading="loadingTable">
      <el-table-column prop="fatherName" label="分类" align="center" width="200"></el-table-column>
      <el-table-column prop="errorType" label="问题名称" align="center">
        <template slot-scope="scope">
          <div v-html="scope.row.errorType"></div>
        </template>
      </el-table-column>
      <el-table-column prop="briefIntroduction" label="问题描述" align="center"></el-table-column>
      <el-table-column label="关键字" align="center">
        <template slot-scope="scope">
          <template v-if="formatKeyWord(scope.row.keyWord).length < scope.row.keyWord.length">
            <el-popover placement="left" width="500" trigger="hover" :content="scope.row.keyWord">
              <span slot="reference">{{ formatKeyWord(scope.row.keyWord) }}</span>
            </el-popover>
          </template>
          <template v-else>
            <span slot="reference">{{ formatKeyWord(scope.row.keyWord) }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" @click="openDialog('edit', scope.row)">编辑</el-button>
          <el-button type="danger" @click="deleteQuestion(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-box" type="flex" justify="center" align="middle">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50, 100, 200, 400]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1200px" @close="closeDialog" top="4vh"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="formDialog" label-width="80px" :model="formDialog" :rules="ruleDialog">
        <el-form-item label="父级" prop="pName">
          <el-select v-model="formDialog.pName" filterable allow-create default-first-option style="width: 100%;"
                     @change="handleSelectParent" :disabled="dialogTitle === '编辑'">
            <el-option v-for="item in listParents" :key="item.id" :label="item.errorType"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题名称" prop="errorType">
          <el-input v-model="formDialog.errorType" placeholder="请输入问题名称"></el-input>
        </el-form-item>
        <el-form-item label="问题描述" prop="briefIntroduction">
          <el-input type="textarea" :rows="3" v-model="formDialog.briefIntroduction" placeholder="请输入问题描述"></el-input>
        </el-form-item>
        <el-form-item label="关键字" prop="keyWord">
          <el-input type="textarea" :rows="3" v-model="formDialog.keyWord" placeholder="请输入问题关键字，用空格分开"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="answer">
          <tinymce ref="tinymce" v-model="formDialog.answer" :height="300" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="confirmDialog" :loading="loadingConfirm">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import { ajaxPost, Baseurl } from '@/api/api/api';

export default {
  name: "Question",
  components: {
    Tinymce,
  },
  data() {
    return {
      page: 1,
      size: 20,
      total: 0,
      queryKeyWord: '',
      listTable: [],
      loadingTable: false,
      dialogTitle: '',
      dialogVisible: false,
      parentItem: '',
      listParents: [],
      formDialog: {
        pName: '',
        pId: '',
        errorType: '',
        briefIntroduction: '',
        keyWord: '',
        answer: '',
      },
      ruleDialog: {
        pName: { required: true, message: '请输入或选择父级', trigger: 'change' },
        errorType: { required: true, message: '请输入问题名称', trigger: 'blur' },
        briefIntroduction: { required: true, message: '请输入问题描述', trigger: 'blur' },
        keyWord: { required: true, message: '请输入关键字', trigger: 'blur' },
      },
      loadingConfirm: false,
    }
  },
  created() {
    this.getListParent()
  },
  watch: {
    queryKeyWord(newVal) {
      if (newVal) {
        this.parentItem = ''
      } else {
        this.parentItem = this.listTable[0]
      }
    },
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getListTable()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getListTable()
    },
    handleSelect() {
      this.page = 1
      this.queryKeyWord = ''
      this.getListTable()
    },
    queryForm() {
      this.page = 1
      this.getListTable()
    },
    formatKeyWord(str) {
      const tempArr = str.split(' ')
      return tempArr.splice(0, 4).join(' ')
    },
    openDialog(type, row) {
      if (type === 'add') {
        this.dialogTitle = '新增'
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.tinymce.setContent('');
        });
      } else if (type === 'edit') {
        this.dialogTitle = '编辑'
        this.dialogVisible = true

        this.formDialog.id = row.id
        this.formDialog.pId = this.listParents.find(item => item.id === row.pid)
        this.formDialog.pName = this.formDialog.pId.errorType
        this.formDialog.errorType = row.errorType
        this.formDialog.briefIntroduction = row.briefIntroduction
        this.formDialog.keyWord = row.keyWord
        this.formDialog.answer = row.answer
        this.$nextTick(() => {
          this.$refs.tinymce.setContent(this.formDialog.answer);
        });
      }
    },
    closeDialog() {
      this.formDialog = this.$options.data().formDialog
    },
    confirmDialog() {
      this.$refs.formDialog.validate((valid) => {
        if (!valid) return
        if (!this.formDialog.answer) {
          this.$message.warning('请输入内容！')
          return
        }
        let API = Baseurl + 'helpController/insert'

        // 给ul li标签添加class
        const rgx = /(?<=(<li))|(?<=(<ul))|(?<=(<ol))/gm
        const str = ' class="no-reset"'
        this.formDialog.answer = this.formDialog.answer.replace(rgx, str)

        const paramsData = {
          errorType: this.formDialog.errorType,
          level: 2,
          pid: this.formDialog.pId.id,
          answer: this.formDialog.answer,
          keyWord: this.formDialog.keyWord,
          briefIntroduction: this.formDialog.briefIntroduction,
        }
        if (this.dialogTitle === '编辑') {
          API = Baseurl + 'helpController/updateHelp'
          paramsData.id = this.formDialog.id
        }
        this.loadingConfirm = true
        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          this.loadingConfirm = false
          if (code === 200) {
            this.dialogVisible = false
            this.getListTable()
            this.$message.success('操作成功')
          }
        })
      })
    },
    handleSelectParent(val) {
      const itemIndex = this.listParents.findIndex(item => item.id === val)
      if (itemIndex === -1) {
        this.increaseParent()
      } else {
        this.formDialog.pId = this.listParents[itemIndex]
      }
    },
    getListParent() {
      const API = Baseurl + 'helpController/selectFather'
      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listParents = data
          if (!data.length) return
          this.parentItem = data[0]
          this.getListTable()
        }
      })
    },
    increaseParent() {
      const API = Baseurl + 'helpController/insert'
      const paramsData = {
        errorType: this.formDialog.pName,
        level: 1,
        pid: 0,
        answer: '',
        keyWord: '',
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.formDialog.pId = data
          if (!this.listParents.length) this.parentItem = data
          this.listParents.push(data)
        }
      })
    },
    getListTable() {
      const API = Baseurl + 'helpController/selectByPid'
      const paramsData = {
        page: this.page,
        size: this.size,
        pid: this.parentItem.id,
        type: '1',
      }
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable = false
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data.list
          this.total = data.total
        }
      })
    },
    deleteQuestion(row) {
      this.$confirm('您确定要执行此操作吗？', '提示').then(() => {
        const API = Baseurl + 'helpController/deleteHelp'
        const paramsData = {
          level: 2,
          id: row.id,
        }
        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          if (code === 200) {
            this.getListTable()
            this.$message.success('操作成功')
          }
        })
      })
    },
    deleteParent() {
      this.$confirm('您确定要执行此操作吗？', '提示').then(() => {
        const API = Baseurl + 'helpController/deleteHelp'
        const paramsData = {
          level: 1,
          id: this.parentItem.id,
        }
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            this.getListParent()
            this.$message.success('操作成功')
          } else {
            this.$message.error(data)
          }
        })
      })
    },
    getKeyWordList() {
      const API = Baseurl + 'helpController/selectByKeyWord'
      const paramsData = {
        page: this.page,
        size: this.size,
        keyWord: this.queryKeyWord,
        type: 1,
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data.list
          this.total = data.total
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.question {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
</style>